import type { FC } from "react";
import type { CardLayoutProps } from "./layout-props";
import { PractitionerAvatar } from "./practitioner-avatar";
import { ProfessionList } from "./profession-list";
import { SkeletonBar } from "./skeleton-bar";
import { SummaryCardMeta } from "./summary-card-meta";
import { VerifiedName } from "./verified-name";

const AdminLayoutSkeleton: FC = () => (
  <>
    <div className="skeleton-bar-dark h-135 w-132 rounded-large" />
    <SkeletonBar tone="dark" className="h-28 w-3/5" />
    <div className="flex w-full flex-col items-center gap-8">
      <SkeletonBar className="w-3/5" />
      <SkeletonBar className="w-2/5" />
      <SkeletonBar className="w-4/5" />
    </div>
    <hr className="w-full border-neutral-light-grey" />
  </>
);

export const AdminLayout: FC<CardLayoutProps> = ({ content, loading }) => {
  if (!content || loading) return <AdminLayoutSkeleton />;

  const { name, professions, location, years, photoUrl, footnote } = content;

  return (
    <>
      <PractitionerAvatar name={name} photoUrl={photoUrl} className="h-135 w-132 rounded-large" />
      <VerifiedName name={name} verified={false} size="m" />
      <SummaryCardMeta
        profession={professions.length > 0 ? <ProfessionList entries={professions} /> : undefined}
        yearsOfExperience={years}
        location={location}
        textClassName="text-16 leading-[1.7]"
      />
      <hr className="w-full border-neutral-light-grey" />
      {footnote && <p className="w-full text-12 text-center text-neutral-black/70">{footnote}</p>}
    </>
  );
};
